<template>
  <div style="width: 100%;">
    <v-col cols="12" sm="12" md="12">
      <v-subheader class="sub-active">Cotas Pagas</v-subheader>
      <v-row class="justCenter cotas">
        <!-- :return-value.sync="valor" -->
        <v-edit-dialog
          :ref="'cota-dialog-'+ano"
          v-for="(ano, index) in anos"
          :key="index"
          :return-value.sync="cotas.find((el)=>{return Number(el.ano) == ano}).valor"
          large
          save-text="Guardar"
          cancel-text="Fechar"
          @close="CloseDialog(ano)"
          @save="GuardarCotas()"
          @open="OpenDialog(ano)"
        >
          <v-chip
            label
            class="ma-2"
            :outlined="!IsPago(ano)"
            :color="IsPago(ano) ? 'success' : 'error'"
            :text-color="IsPago(ano) ? 'white' : 'error'"
          >
            {{ano}}
            <v-icon
              class="cota-icon"
              v-if="IsPago(ano)"
              small
              right
              v-on:click.stop.prevent="Exportar(ano)"
            >mdi-download</v-icon>
          </v-chip>
          <span
            class="valor-cota"
          >{{cotas.find((el)=>{return Number(el.ano) == ano}).valor+'€' || '-'}}</span>
          <template v-slot:input>
            <v-text-field
              type="number"
              min="0"
              value="12.00"
              step=".1"
              :color="$primary"
              v-model="cotas.find((el)=>{return Number(el.ano) == ano}).valor"
              single-line
            ></v-text-field>
          </template>
        </v-edit-dialog>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import CRUD from "@/mixins/_CRUD"
import COTAS from "@/mixins/_COTAS"
export default {
  mixins: [CRUD, COTAS],
  props: {
    MyObject: Object,
    Store: String
  },
  data: () => ({
    ano: 0,
    tmp: null,
    stop: false
  }),
  created() {
    this.ano = Number(this.MyObject.ano_inicio)
  },
  computed: {
    anos() {
      return this.ano > 0
        ? Array.from(
            new Array(Number(this.$moment().year()) - this.ano + 1),
            (x, i) => i + this.ano
          )
        : []
    },
    anos_pagos() {
      return this.MyObject.anos_pagos ? this.MyObject.anos_pagos.split(",") : []
    },
    valores_pagos() {
      return this.MyObject.valores_pagos
        ? this.MyObject.valores_pagos.split(",")
        : []
    },
    cotas() {
      return this.anos
        ? this.anos.map((el, index) => {
            return {
              ano: el,
              valor: parseFloat(this.valores_pagos[index]).toFixed(2)
            }
          })
        : []
    }
  },
  methods: {
    Exportar(ano) {
      if (this.stop) return

      this.stop = true
      var file = this.$moment().unix()

      this.$eventBus.$emit("ExportarPdf", "ComprovativoCota", {
        nome: this.MyObject.utilizador,
        data: this.MyObject.data,
        email: this.MyObject.email,
        nif: this.MyObject.nif,
        valor: this.cotas.find(el => {
          return Number(el.ano) == ano
        }).valor,
        ano: ano,
        file: file
      })

      setTimeout(() => {
        this.$refs["cota-dialog-" + ano][0].cancel()
      }, 50)

      setTimeout(() => {
        this.stop = false
      }, 2000)
    },
    IsPago(ano) {
      return (
        parseFloat(
          this.cotas.find(el => {
            return Number(el.ano) == Number(ano)
          }).valor
        ) > 0
      )
    },
    OpenDialog(ano) {
      if (this.tmp != null) return

      this.tmp = Object.assign(
        {},
        this.cotas.find(el => {
          return Number(el.ano) == ano
        })
      )
      this.cotas.find(el => {
        return Number(el.ano) == ano
      }).valor =
        parseFloat(
          this.cotas.find(el => {
            return Number(el.ano) == ano
          }).valor
        ) > 0
          ? this.cotas.find(el => {
              return Number(el.ano) == ano
            }).valor
          : this.$cotas
    },
    CloseDialog(ano) {
      this.cotas.find(el => {
        return Number(el.ano) == ano
      }).valor =
        this.cotas.find(el => {
          return Number(el.ano) == ano
        }).valor != this.tmp.valor
          ? this.cotas.find(el => {
              return Number(el.ano) == ano
            }).valor
          : this.tmp.valor

      setTimeout(() => {
        this.tmp = null
      }, 200)
    }
  }
}
</script>

<style scoped>
.sub-active {
  background-color: rgba(158, 158, 158, 0.3) !important;
  color: #505050 !important;
}

.valor-cota {
  font-size: 10px !important;
  margin-top: -10px !important;
}

.cota-icon {
  font-size: 16px !important;
  background-color: #439846 !important;
  height: 100% !important;
  margin-right: -12px !important;
  width: 25px !important;
  cursor: pointer !important;
}
</style>
